import authSaga from './auth/sagas';

export default [authSaga()];
